<template>
    <v-app id="contact-form" class="grey lighten-4">
        <div class="d-flex justify-center my-5">
            <v-container class="custom-contact-container" justify-center>
                <v-container grid-list-md text-xs-center>
                    <v-layout row wrap justify-center>
                        <v-flex xs12 md8>
                            <v-layout column>
                                <v-flex xs12 class="text-center mb-4">
                                    <h2 class="custom-contact-heading">Wiadomość dla administratora</h2>
                                </v-flex>

                                <v-flex xs12 class="mb-3">
                                    <v-text-field v-model="formData.name" browser-autocomplete="off"
                                        label="Imię i nazwisko / Nazwa podmiotu"
                                        aria-label="label for subsidiary polish name" outlined color="primary" dense
                                        class="custom-contact-input" :disabled="isUserLoggedIn"></v-text-field>
                                </v-flex>

                                <v-flex xs12 class="mb-3">
                                    <v-text-field v-model="formData.phone" browser-autocomplete="off"
                                        label="Numer telefonu" aria-label="label for phone number" outlined
                                        color="primary" dense class="custom-contact-input" data-vv-name="phone"
                                        data-vv-as="numer telefonu" :error-messages="vErrors.collect('phone')"
                                        v-validate="'numeric'" :disabled="isUserLoggedIn"></v-text-field>
                                </v-flex>

                                <v-flex xs12 class="mb-3">
                                    <v-text-field v-model="formData.email" browser-autocomplete="off"
                                        label="Adres email" aria-label="label for email" outlined color="primary" dense
                                        class="custom-contact-input" data-vv-name="email" data-vv-as="email"
                                        :error-messages="vErrors.collect('email')" v-validate="'required|email'"
                                        :disabled="isUserLoggedIn || isEmailBlocked"></v-text-field>
                                </v-flex>

                                <v-flex xs12 class="mb-3">
                                    <v-textarea v-model="formData.message" browser-autocomplete="off" label="Wiadomość"
                                        aria-label="label for message" outlined color="primary" dense
                                        class="custom-contact-textarea" data-vv-name="wiadomość" data-vv-as="wiadomość"
                                        :error-messages="vErrors.collect('wiadomość')"
                                        v-validate="'required'"></v-textarea>
                                </v-flex>

                                <v-flex xs12 class="text-center mt-3">
                                    <v-btn color="primary" dark large class="custom-btn" @click="send">Wyślij
                                        wiadomość</v-btn>
                                </v-flex>

                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-container>
        </div>
    </v-app>
</template>

<script>
import { Api } from "@/api";
import { Contact } from "@/api/generated/Contact";
import { showRecaptchaBadge, hideRecaptchaBadge } from "@/utils/Recaptcha";

export default {
    name: "ContactView",
    data() {
        return {
            formData: {
                name: null,
                phone: null,
                email: null,
                message: null,
                recaptchaToken: null,
            },
            recaptchaPublicKey: process.env.VUE_APP_PUBLIC_RECAPTCHA_KEY,
            isUserLoggedIn: false,
            isEmailBlocked: false,
            defaultResetMessage: `Proszę o usunięcie urządzenia z systemu (restart konta). 
Celem restartu konta jest wyświetlenie na ekranie uwierzytelniania kodu QR umożliwiającego konfigurację aplikacji do generowania jednorazowych kodów dostępu.`,
        };
    },
    props: {
        email: {
            type: String,
            default: "",
        },
        message: {
            type: String,
            default: "",
        },
    },
    methods: {
        async send() {
            const isValid = await this.$validator.validateAll();
            if (!isValid) return;

            await this.executeRecaptcha();
            this.sendRequest();
        },

        async executeRecaptcha() {
            return new Promise((resolve, reject) => {
                if (!this.recaptchaPublicKey) {
                    resolve();
                    return;
                }
                // eslint-disable-next-line no-undef
                grecaptcha.enterprise.ready(() => {
                    // eslint-disable-next-line no-undef
                    grecaptcha.enterprise.execute(this.recaptchaPublicKey, { action: "submit" })
                        .then((token) => {
                            this.formData.recaptchaToken = token;
                            resolve();
                        })
                        .catch((error) => reject(error));
                });
            });
        },
        sendRequest() {
            Contact.postSend(this, this.formData,
                successResponse => {
                    this.$messagesBus.$emit("success", "Wiadomość została wysłana", successResponse);
                    this.resetForm();
                    this.$router.go(-1);
                },
                errorResponse => {
                    this.$messagesBus.$emit("error", "Nie udało się wysłać wiadomości", errorResponse);
                });
        },
        addRecaptcha() {
            showRecaptchaBadge(this.recaptchaPublicKey);
        },
        loadUserData() {
            Api.get(this, "/user/user-info",
                successResponse => {
                    this.formData.name = successResponse.fullName;
                    this.formData.phone = successResponse.phone;
                    this.formData.email = successResponse.email;
                },
                errorResponse => {
                    this.$messagesBus.$emit("error", "Nie udało się załadować danych!", errorResponse);
                });
        },
        resetForm() {
            if (!this.logged) {
                this.formData.name = null;
                this.formData.phone = null;
                this.formData.email = null;
            }
            this.formData.message = null;
            this.formData.recaptchaToken = null;

            this.$validator.reset();
        }
    },
    created() {
        this.addRecaptcha();
        this.formData.email = this.email;

        if (this.email) {
            this.isEmailBlocked = true;
            this.formData.message = this.defaultResetMessage;
        }
    },
    beforeDestroy() {
        hideRecaptchaBadge();
    },
    mounted() {
        if (!this.email && sessionStorage["role"]) {
            this.isUserLoggedIn = true;
            this.loadUserData();
        }
    }

};
</script>

<style scoped>
.custom-contact-heading {
    font-size: 28px;
    color: #1976d2;
}

.custom-contact-container {
    border: 1px solid #cfd8dc;
    border-radius: 8px;
    padding: 40px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
}


.custom-contact-input,
.custom-contact-textarea {
    background-color: #fafafa;
    border-radius: 6px;
    padding: 10px;
    padding-bottom: 0px;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}
</style>